module.exports = __webpack_public_path__ + "static/img/websit_icon.b3274b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/list/websit_icon.png
// module id = 6dBx
// module chunks = 24